<script>
import api from '@/helpers/api'
export default {
  name: 'shop-select',
  props: {
    value: { type: [Array, String] },
    multiple: { type: Boolean, default: true }
  },

  data: vm => ({
    shops: [],
    selected: null
  }),
  methods: {
    async loadData (needle = null) {
      let { items } = await api.shops.fetchPage({
        page: 1,
        pageSize: -1,
        filters: [{ is_active: { _eq: true } }],
        needle
      })

      this.shops = [...items]

      return items
    },
    onSelected (items) {
      let id
      if (!items) return this.emitChanges(null)
      if (this.multiple) {
        id = items.map(s => s.id)
      } else {
        id = items.id
      }
      this.emitChanges(id)
    },
    emitChanges (v) {
      this.$emit('input', v)
      this.$emit('select', v)
    }
  },
  watch: {
    value: {
      async handler (val) {
        if (this.shops.length <= 0) {
          await this.loadData()
        }

        if (!val) return
        if (this.multiple) {
          this.selected = this.shops.filter(s => val.includes(s.id))
        } else {
          this.selected = this.shops.find(s => s.id == val)
        }
      },
      immediate: true
    }
  },
  computed: {
    listeners () {
      return { ...this.$listeners, select: 'onSelected' }
    }
  }
}
</script>
<template>
  <g-tag-input
    v-model="selected"
    v-bind="$attrs"
    :async-suggestions="loadData"
    suggestion-is-object
    label-key="name"
    value-key="id"
    placeholder="Select shops..."
    v-on:input="onSelected"
  />
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}
</style>
